import React from 'react';
import AnchorContent from './internal/AnchorContent';
import BreadcrumbContext from './internal/BreadcrumbContext';
const Anchor = ({ title = '...', route, hasQuickLinkButton = true, children, }) => {
    const { depth } = React.useContext(BreadcrumbContext);
    return (<AnchorContent depth={depth} hasQuickLinkButton={hasQuickLinkButton} route={route} title={title}>
      {children}
    </AnchorContent>);
};
export default Anchor;
